// Compose modal: recipient links are injected via AJAX; handle picks explicitly so
// selection works even when Rails UJS does not bind to replaced HTML.

function bindComposeRecipientPicks() {
  const modal = document.getElementById("composeModal");
  if (!modal || modal.dataset.composeRecipientPickBound === "1") return;
  modal.dataset.composeRecipientPickBound = "1";

  modal.addEventListener("click", function (e) {
    const a = e.target.closest("a.compose-recipient-pick");
    if (!a || !modal.contains(a)) return;
    e.preventDefault();
    e.stopPropagation();

    const href = a.getAttribute("href");
    if (!href) return;

    const $ = window.jQuery;
    if (!$ || !$.ajax) return;

    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
    $.ajax({
      url: href,
      type: "GET",
      dataType: "script",
      beforeSend(xhr) {
        if (token) xhr.setRequestHeader("X-CSRF-Token", token);
      },
    });
  });
}

document.addEventListener("turbolinks:load", bindComposeRecipientPicks);
